/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Verify_Email_ContinueInputs */

const en_common_sign_verify_email_continue = /** @type {(inputs: Common_Sign_Verify_Email_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const zh_common_sign_verify_email_continue = /** @type {(inputs: Common_Sign_Verify_Email_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Common_Sign_Verify_Email_ContinueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_verify_email_continue = /** @type {((inputs?: Common_Sign_Verify_Email_ContinueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Verify_Email_ContinueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_verify_email_continue(inputs)
	return zh_common_sign_verify_email_continue(inputs)
});
export { common_sign_verify_email_continue as "common.sign.verify_email_continue" }